import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class GroundSensor extends Sensor {
  public waterVolumeChart: any;
  public condChart: any;
  public condSatChart: any;
  public tempChart: any;

  private waterSensor: any[];
  private condSensor: any[];
  private tempSensor: any[];
  private condSatSensor: any[];
  private roundedwaterSensor: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.waterVolumeChart = null;
    this.condChart = null;
    this.condSatChart = null;
    this.tempChart = null;

    this.waterSensor = [[],[],[]];
    this.tempSensor = [[], [], []];
    this.condSensor = [[],[],[]];
    this.roundedwaterSensor = [[],[],[]];
    this.condSatSensor = [[], [], []];
  }

  public hasWaterSensor(pos: number): boolean {
    return this.waterSensor[pos - 1].length > 0;
  }

  public getWaterSensor(pos: number): any {
    const realPos: number = this.waterSensor[pos - 1].length - 1;
    return this.waterSensor[pos - 1][realPos][1] ?? null;
  }

  public hasCondSensor(pos: number): boolean {
    return this.condSensor[pos - 1].length > 0;
  }

  public getCondSensor(pos: number): any {
    const realPos: number = this.condSensor[pos - 1].length - 1;
    return this.condSensor[pos - 1][realPos][1] ?? null;
  }

  public hasCondSatSensor(pos: number): boolean {
    return this.condSatSensor[pos - 1].length > 0;
  }

  public getCondSatSensor(pos: number): any {
    const realPos: number = this.condSatSensor[pos - 1].length - 1;
    return this.condSatSensor[pos - 1][realPos][1] ?? null;
  }

  public hasTempSensor(pos: number): boolean {
    return this.tempSensor[pos - 1].length > 0;
  }

  public getTempSensor(pos: number): any {
    const realPos: number = this.tempSensor[pos - 1].length - 1;
    return this.tempSensor[pos - 1][realPos][1] ?? null;
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      this.tempSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.temperature,
      ]);

      this.condSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.conductivity,
      ]);

      this.waterSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.water,
      ]);

      this.roundedwaterSensor[element.position].push(Math.round(element.water));

      this.condSatSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.extSat,
      ]);
    }
  }

  public setCharts(): void {
    this.waterVolumeChart = this.getConfigChar(
      'volumen',
      this.getChartSeries('hum', this.waterSensor),
      this.getRanges('1_water'),
      this.getLimits('1_water')
    );
    this.condChart = this.getConfigChar(
      'suelo',
      this.getChartSeries('ec', this.condSensor),
      this.getRanges('1_conductivity'),
      this.getLimits('1_conductivity')
    );
    this.condSatChart = this.getConfigChar(
      'extracto',
      this.getChartSeries('extsat3', this.condSatSensor),
      this.getRanges('1_extSat'),
      this.getLimits('1_extSat')
    );
    this.tempChart = this.getConfigChar(
      'temperatura',
      this.getChartSeries('temp', this.tempSensor),
      this.getRanges('1_temperature'),
      this.getLimits('1_temperature')
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Contenido volumétrico de agua', value: '1_water' },
      { title: 'Conductividad de suelo', value: '1_conductivity' },
      { title: 'Conductividad extracto saturado', value: '1_extSat' },
      { title: 'Temperatura', value: '1_temperature' },
    ];
  }
}